const errorTraces = {
  playbackTokenRequestError: {
    code: "571116",
    dump: { trace: "", placeInCode: "Authentication SDK Module - getPlaybackToken method" }
  },
  addDeviceError: { code: "571103", dump: { trace: "", placeInCode: "User SDK Module - addDevice method" } },
  playbackRequestTimeout: {
    code: "571198",
    dump: { trace: "Playback related request timeout", placeInCode: "", timedOutCall: "" }
  }
};

export function getErrorTrace(key) {
  return errorTraces[key];
}
